import PortfolioHome from "./Home";
import PortfolioProjects from "./Projects";
import { Navigate, Route, Routes } from "react-router";
export default function Portfolio() {
    return(
        <div id="wd-Portfolio" className="row me-3 ms-3 pb-3 pt-1">  
        <div className="col-lg-1">
        </div>
        <div className="col-lg-10">  
        <Routes>
            <Route path="/" element={<PortfolioHome/>}/>
            <Route path=":pid/*" element={<PortfolioProjects/>} />
        </Routes>
        </div>
        <div className="col-lg-1 mb-3">
        </div>
        </div>
    );
}